export interface SearchFilterProps {
  name?: string;
  searchTerm?: string;
  onChange: (searchTerm: string | null) => void;
}

export const SearchFilter = ({ name, searchTerm, onChange }: SearchFilterProps) => {
  return (
    <div className="search-filter">
      <input
        type="search"
        placeholder={`Search${name ? ' ' + name : ''}...`}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value || null)}
        value={searchTerm ?? ''}
      />
    </div>
  );
};
